<template>
  <div class="order-list">
    <van-nav-bar
      title="订单信息"
      right-text="刷新"
      @click-right="query"
    />
    <div class="van-address-edit">
      <div class="van-address-edit__fields">
        <van-row v-if="loading">
          <van-col :span="24">
            <van-loading size="24px" vertical>正在努力加载数据...</van-loading>
          </van-col>
        </van-row>
        <template v-for="row in data">
          <div class="order-list-card">
            <van-panel :key="row.id">
              <div style="padding: 10px 10px;">
                <span v-for="detail in row.details" class="order-list-item">
                  {{ detail.goods_name }} × {{ detail.count }}<br>
                </span>
              </div>
              <template #header>
                <van-row style="padding: 10px 10px;">
                  <van-col :span="17">
                    <span class="order-code">
                      &nbsp;{{ row.receiver }}
                    </span>
                  </van-col>
                  <van-col :span="7" style="text-align: right">
                    <span class="order-price">
                      ￥{{ row.total_amount | toThousandFilter }}
                    </span>
                  </van-col>
                </van-row>
              </template>
              <template #footer>
                <van-row>
                  <van-col :span="2">
                    <van-icon name="clock" class="order-list-clock" />&nbsp;
                  </van-col>
                  <van-col :span="12">
                    <span class="order-list-date">
                      {{ row.delivery_time }}
                    </span>
                  </van-col>
                  <van-col :span="10" style="text-align: right;">
                    <van-tag plain type="danger">{{ row.shop_name }}</van-tag>
                  </van-col>
                </van-row>
              </template>
            </van-panel>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { listByMemberOfSellOrder } from '@/api/wx-fwh'
export default {
  name: 'WxSellOrderList',
  data() {
    return {
      loading: false,
      data: []
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      this.loading = true
      this.data = []
      listByMemberOfSellOrder({
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'delivery_time',
        order: 'desc'
      }).then(resp => {
        this.data = resp.rows || []
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
  .order-list {
    color: #323233;
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
      Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
  }
  .order-list-card {
    margin-top: 20px;
  }
  .order-list-item {
    font-size: 12px;
  }
  .order-list-date {
    font-size: 14px;
  }
  .order-list-clock {
    color: skyblue;
    font-size: 18px;
  }
  .order-code {
    font-size: 14px;
  }
  .order-price {
    color: darkorange;
    font-size: 18px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/wxfwh/sell-order/sell-order-list.vue